(function () {
  if (window.__auFicheBound) return;
  window.__auFicheBound = true;

  function activate(root, key) {
    root.querySelectorAll('[data-auf-tab]').forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-auf-tab') === key); });
    root.querySelectorAll('[data-auf-panel]').forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-auf-panel') === key); });
  }

  function trackStep(track, dir) {
    var first = track.firstElementChild;
    var w = first ? first.getBoundingClientRect().width + 18 : 300;
    track.scrollBy({ left: dir * w, behavior: 'smooth' });
  }

  function nearestIndex(track) {
    var tr = track.getBoundingClientRect(), mid = tr.left + tr.width / 2, best = 0, bestD = Infinity;
    Array.prototype.forEach.call(track.children, function (k, i) {
      var r = k.getBoundingClientRect(), d = Math.abs(r.left + r.width / 2 - mid);
      if (d < bestD) { bestD = d; best = i; }
    });
    return best;
  }

  function scrollToItem(track, idx) {
    var k = track.children[idx];
    if (!k) return;
    var tr = track.getBoundingClientRect(), r = k.getBoundingClientRect();
    var left = track.scrollLeft + (r.left - tr.left) - (track.clientWidth - r.width) / 2;
    track.scrollTo({ left: left, behavior: 'smooth' });
  }

  function syncDots(root) {
    var track = root.querySelector('[data-auf-track]');
    var dots = root.querySelectorAll('[data-auf-dot]');
    if (!track) return;
    var best = nearestIndex(track);
    Array.prototype.forEach.call(track.children, function (k, i) { k.classList.toggle('is-center', i === best); });
    dots.forEach(function (d, i) { d.classList.toggle('is-active', i === best); });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;

    var tab = t.closest('[data-auf-tab]');
    if (tab) {
      var root = tab.closest('[data-auf-root]');
      if (root) activate(root, tab.getAttribute('data-auf-tab'));
      return;
    }

    var step = t.closest('[data-auf-step]');
    if (step) {
      var r = step.closest('[data-auf-root]');
      if (!r) return;
      var dir = parseInt(step.getAttribute('data-auf-step'), 10) || 1;
      var tabs = r.querySelectorAll('[data-auf-tab]');
      if (tabs.length) {
        var arr = Array.prototype.slice.call(tabs);
        var cur = arr.findIndex(function (b) { return b.classList.contains('is-active'); });
        activate(r, arr[(cur + dir + arr.length) % arr.length].getAttribute('data-auf-tab'));
        return;
      }
      var tr = r.querySelector('[data-auf-track]');
      if (tr) trackStep(tr, dir);
      return;
    }

    var dot = t.closest('[data-auf-dot]');
    if (dot) {
      var dr = dot.closest('[data-auf-root]');
      var trk = dr && dr.querySelector('[data-auf-track]');
      var idx = parseInt(dot.getAttribute('data-auf-dot'), 10);
      if (trk) scrollToItem(trk, idx);
      return;
    }

    var vid = t.closest('[data-auf-video]');
    if (vid) {
      var v = vid.querySelector('video');
      var play = vid.querySelector('.auf-vs__play');
      if (v) {
        if (v.paused) { v.play(); if (play) play.hidden = true; } else { v.pause(); if (play) play.hidden = false; }
      }
    }
  });


  function initAutoplay(root) {
    if (root.__aufAuto) return;
    var delay = parseInt(root.getAttribute('data-auf-autoplay'), 10);
    if (!delay || delay < 1500) return;
    if (window.Shopify && window.Shopify.designMode) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    root.__aufAuto = true;
    var track = root.querySelector('[data-auf-track]');
    var visible = false, paused = false, resumeT;

    function playing() {
      return Array.prototype.some.call(root.querySelectorAll('video'), function (v) { return !v.paused && !v.ended; });
    }
    function step() {
      if (!visible || paused || document.hidden || playing()) return;
      if (track) {
        if (track.scrollWidth <= track.clientWidth + 4) return;
        scrollToItem(track, (nearestIndex(track) + 1) % track.children.length);
        return;
      }
      var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-auf-tab]'));
      if (tabs.length < 2) return;
      var cur = tabs.findIndex(function (b) { return b.classList.contains('is-active'); });
      activate(root, tabs[(cur + 1) % tabs.length].getAttribute('data-auf-tab'));
    }
    function pause(ms) {
      paused = true; clearTimeout(resumeT);
      resumeT = setTimeout(function () { paused = false; }, ms);
    }
    ['pointerdown', 'touchstart', 'keydown', 'wheel'].forEach(function (ev) {
      root.addEventListener(ev, function () { pause(9000); }, { passive: true });
    });
    root.addEventListener('mouseenter', function () { paused = true; clearTimeout(resumeT); });
    root.addEventListener('mouseleave', function () { pause(1500); });
    root.addEventListener('focusin', function () { pause(9000); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { visible = es[0].isIntersecting; }, { threshold: 0.35 }).observe(root);
    } else { visible = true; }
    setInterval(step, delay);
  }

  function bindTracks() {
    document.querySelectorAll('[data-auf-root]').forEach(function (root) {
      var track = root.querySelector('[data-auf-track]');
      if (!track || track.__aufBound) return;
      track.__aufBound = true;
      var t;
      track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(function () { syncDots(root); }, 60); }, { passive: true });
      syncDots(root);
    });
    document.querySelectorAll('[data-auf-autoplay]').forEach(initAutoplay);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bindTracks); else bindTracks();
  document.addEventListener('shopify:section:load', bindTracks);
  document.addEventListener('shopify:block:select', function (e) {
    var el = e.target;
    if (!el || !el.closest) return;
    var root = el.closest('[data-auf-root]');
    var key = el.getAttribute('data-auf-tab') || el.getAttribute('data-auf-panel');
    if (root && key) activate(root, key);
  });
})();
